import React, { useEffect, useState }from 'react';
import axios from "axios";
import { axiosLink } from '../../axiosLink';
import Token from "../../Utils/Token"
import { useNavigate } from 'react-router-dom';
import DataDetails from './DataDetails';

const FranchisingDashboard = () => {
    const [data, setData] = useState();
    const [dataDetails, setDataDetails] = useState();
    const [itemToDelete, setItemToDelete] = useState(null);
    const [isSuperAdmin, setIsSuperAdmin] = useState(false);
    const { activeToken } = Token();
    const navigate = useNavigate();
  
    useEffect(() => {
        axios.get(
            `${axiosLink}/franchising/all`,
            {
                headers: {
                Authorization: activeToken,
                'Content-Type': 'application/json',
                },
            }
        ).then((res) => {
            if(!res.data?.errMsg) {
                setData(res?.data)
            } else {
                navigate("/")
            }
        })
    }, [activeToken, navigate]);

    useEffect(() => {
        try {
            const sa = localStorage.getItem('superAdmin');
            setIsSuperAdmin(sa === 'true');
        } catch (e) {
            setIsSuperAdmin(false);
        }
    }, []);

    const confirmDelete = async () => {
        if (!itemToDelete) return;
        try {
            await axios.delete(
                `${axiosLink}/franchising/${itemToDelete.id}`,
                {
                    headers: {
                        Authorization: activeToken,
                        'Content-Type': 'application/json',
                    },
                }
            );
            setData((prev) => Array.isArray(prev) ? prev.filter((el) => el.id !== itemToDelete.id) : prev);
            setItemToDelete(null);
        } catch (e) {
            setItemToDelete(null);
            // Optionally handle error UI
        }
    };
    return (
        <>
            <h3>Franchising</h3>
            <DataDetails data={dataDetails} close={(e) => setDataDetails(e)}/>
            {isSuperAdmin && itemToDelete && (
                <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ background: '#fff', padding: 20, maxWidth: 400, width: '90%', borderRadius: 6 }}>
                        <h4 style={{ marginTop: 0 }}>Delete franchise</h4>
                        <p>Are you sure you want to delete "{itemToDelete.contactform_fullName}"?</p>
                        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
                            <button onClick={() => setItemToDelete(null)}>Cancel</button>
                            <button onClick={confirmDelete} style={{ background: '#c0392b', color: '#fff' }}>Delete</button>
                        </div>
                    </div>
                </div>
            )}
            <table className='w-100'>
                <tbody>
                <tr>
                    <th>Fullname</th>
                    <th>Phone</th>
                    <th>E-mail</th>
                    <th>Details</th>
                    <th>State</th>
                    <th>Created date</th>
                    {isSuperAdmin && <th>Action</th>}
                </tr>
                {data && data?.map((el) => (
                    <tr key={el.id} style={{ borderBottom: "1pt solid black" }}>
                        <td>{el.contactform_fullName}</td>
                        <td>{el.contactform_phone}</td>
                        <td>{el.contactform_email}</td>
                        <td><button onClick={() => setDataDetails(el)}>View Details</button></td>
                        <td> {el.state}</td>
                        <td>{el.createdAt}</td>
                        {isSuperAdmin && <td><button onClick={() => setItemToDelete(el)} style={{ color: '#c0392b' }}>X</button></td>}
                    </tr>
                ))}
                </tbody>
            </table>
        </>
  )
}

export default FranchisingDashboard;